var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m433 512 314 314q21 21 21 51.5T747 929q-22 22-52 22t-52-22L277 564q-21-21-21-51.5t21-51.5L643 95q22-22 52-22t52 22q21 21 21 51.5T747 198L433 512z"
  })));
};
export { SvgChevronLeft as ReactComponent };
export default __webpack_public_path__ + "ae8e46ca6a47e6a287bfe17d4aca11a5.svg";